import React, { useState, useEffect } from 'react';
import { apiClient } from '../services/api';
import './SalesStartProgress.css';

interface WhiteListStatsSubset {
  total_spots: number;
  remaining_spots: number;
  white_list_start_date: string;
}

interface SalesStartProgressProps {
  /**
   * White List stats provided by the parent (HomePage already fetches them),
   * so this component doesn't issue a duplicate GET /white-list/stats.
   */
  wlStats?: WhiteListStatsSubset | null;
}

export const SalesStartProgress: React.FC<SalesStartProgressProps> = ({ wlStats = null }) => {
  const [nftStats, setNftStats] = useState<{ total: number; available: number } | null>(null);

  useEffect(() => {
    const load = async () => {
      try {
        const stats = await apiClient.getNftStats();
        setNftStats(stats);
      } catch {
        // ignore
      }
    };
    load();
  }, []);

  if (!nftStats) return null;

  const total = wlStats?.total_spots ?? nftStats.total;
  const available = wlStats ? wlStats.remaining_spots : nftStats.available;

  const progressPercent =
    total > 0 ? ((total - available) / total) * 100 : 0;

  return (
    <div className="sales-start-progress-section">
      <div className="progress-top-row">
        <span className="progress-top-label">До старта продаж:</span>
        <span className="progress-top-value">
          {available}{' '}
          <span className="progress-top-total">/ {total} мест</span>
        </span>
      </div>
      <div className="progress-bar-container">
        <div className="progress-bar-horizontal">
          <div
            className="progress-bar-fill"
            style={{ width: `${progressPercent}%` }}
          />
        </div>
      </div>
      <span className="progress-bottom-note">
        Только для участников White list
      </span>
    </div>
  );
};
